import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Loading } from '@folio/stripes/components';
import ProposalCreate from './ProposalCreate';
import ProposalCreateFromRecord from './ProposalCreateFromRecord';
import ProposalEdit from './ProposalEdit';
import ProposalsReport from './ProposalsReport';
import useProposalDetail from '../hooks/useProposalDetail';
import { ProposalStatus } from '../types/api';
var AUTHORITIES_PATH = '/czna-authorities/authorities';
var INBOX_PATH = '/czna-authorities/inbox';
var legacyListPath = function (search) {
    var tab = new URLSearchParams(search).get('tab');
    if (tab === 'CHANGES_REQUESTED')
        return INBOX_PATH;
    if (tab === 'REJECTED' || tab === 'APPROVED')
        return "".concat(AUTHORITIES_PATH, "/archive");
    if (tab === 'PENDING_NEW' || tab === 'PENDING_UPDATE' || tab === 'PENDING_NATIONAL' || tab === 'PENDING_REVIEW') {
        return INBOX_PATH;
    }
    return "".concat(AUTHORITIES_PATH, "/my-drafts");
};
/**
 * The workspace a proposal belongs to, by status — for entry points that have no section of
 * their own (legacy `/proposals/:id` links, a record's source proposal).
 *
 * CZNA-1190: `AuthoritiesList` used this for its combined record+proposal rows (CZNA-974) and
 * so threw the user out of the search into the review queue or another tab.
 *
 * CZNA-1446: both returned and pending proposals open in the Inbox — the review queue is the
 * administrator's alone now, and the detail pane loads by id whatever the list holds. It no longer does — a
 * click opens the detail where the user already is (`/authorities/proposals/:id`).
 */
export var proposalPath = function (status, id) {
    if (status === ProposalStatus.CHANGES_REQUESTED)
        return "".concat(INBOX_PATH, "/proposals/").concat(id);
    if (status === ProposalStatus.REJECTED || status === ProposalStatus.APPROVED) {
        return "".concat(AUTHORITIES_PATH, "/archive/").concat(id);
    }
    if (status === ProposalStatus.PENDING_REVIEW || status === ProposalStatus.PENDING_NATIONAL_REVIEW) {
        return "".concat(INBOX_PATH, "/proposals/").concat(id);
    }
    return "".concat(AUTHORITIES_PATH, "/my-drafts/").concat(id);
};
var LegacyProposalDetailRedirect = function (_a) {
    var id = _a.id, search = _a.search;
    var _b = useProposalDetail(id), proposal = _b.proposal, isLoading = _b.isLoading;
    if (isLoading)
        return React.createElement(Loading, null);
    return (React.createElement(Redirect, { to: {
            pathname: proposal ? proposalPath(proposal.status, id) : "".concat(AUTHORITIES_PATH, "/my-drafts/").concat(id),
            search: search,
        } }));
};
var Proposals = function (_a) {
    var match = _a.match;
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: "".concat(match.path, "/create"), component: ProposalCreate }),
        React.createElement(Route, { exact: true, path: "".concat(match.path, "/:id/edit"), component: ProposalEdit }),
        React.createElement(Route, { exact: true, path: "".concat(match.path, "/report"), render: function () { return React.createElement(ProposalsReport, { listPath: match.path }); } }),
        React.createElement(Route, { exact: true, path: "".concat(match.path, "/new"), component: ProposalCreateFromRecord }),
        React.createElement(Route, { exact: true, path: "".concat(match.path, "/:id"), render: function (routeProps) { return (React.createElement(LegacyProposalDetailRedirect, { id: routeProps.match.params.id, search: routeProps.location.search })); } }),
        React.createElement(Route, { exact: true, path: match.path, render: function (routeProps) { return (React.createElement(Redirect, { to: {
                    pathname: legacyListPath(routeProps.location.search),
                    search: routeProps.location.search,
                } })); } })));
};
export default Proposals;
